import tagTester from './_tagTester.js';

export default tagTester('Symbol');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isSymbol.js
// module id = 442
// module chunks = 0